import { css } from 'twin.macro';
import React, { useState, Fragment } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FaMicrophone } from 'react-icons/fa';
import { connect } from 'react-redux';
import AudioRecorder from '@/lib/AudioRecorder';

const AudioRecordModal = ({ currUser, buttonMode, ...props }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    if (!currUser || !currUser?._id) {
        return null;
    }

    return (
        <Fragment>
            {buttonMode ? (
                <Button variant="outline-secondary" className="mb-2" onClick={handleShow}>
                    <FaMicrophone
                        fontSize="22px"
                        css={css`
                            margin: 0 3px;
                        `}
                        className="cursor-pointer"
                        aria-label="Record Audio"
                    />
                    Record Voice
                </Button>
            ) : (
                <FaMicrophone
                    fontSize="22px"
                    css={css`
                        margin: 0 3px;
                    `}
                    className="cursor-pointer"
                    onClick={handleShow}
                    aria-label="Record Audio"
                />
            )}

            <Modal show={show} onHide={handleClose} size="" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    <strong>
                        <p className="text-center">Record Audio</p>
                    </strong>
                    <div className="d-flex flex-row align-items-center justify-content-center">
                        <AudioRecorder handleClose={handleClose} {...props} />
                    </div>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    teams: state.teams.teams,
    currUser: state.user.user,
});
export default connect(mapStateToProps, {})(AudioRecordModal);
